export default __webpack_public_path__ + "static/media/logo-white.b5331620.svg";